/**
 * My.Good-Loop
 */
const GLAppManifest = {
	name: "My.Good-Loop",
	id: "my.good-loop.com",
	dataspace: "good-loop",
	logo: "/img/My-Good-Loop-lockup.svg",
	// logoMobile: "/img/My-Good-Loop-lockup-vertical.svg",
	website: "https://good-loop.com",	
	facebookAppId: "320927325010346", // https://developers.facebook.com/apps/320927325010346/dashboard/
	privacyPolicy: "https://doc.good-loop.com/privacy-policy.html",
	tsncs: "https://doc.good-loop.com/terms/terms-of-use.html",
	instagramLink: "https://www.instagram.com/goodloophq/",
	facebookLink: "https://www.facebook.com/the.good.loop/",
	twitterLink: "https://twitter.com/goodloophq",
};

module.exports = GLAppManifest;
